var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_2342",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19843 16.6449C13.3111 16.6449 16.6449 13.3111 16.6449 9.19843C16.6449 5.08578 13.3111 1.75195 9.19843 1.75195C5.08578 1.75195 1.75195 5.08578 1.75195 9.19843C1.75195 13.3111 5.08578 16.6449 9.19843 16.6449Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.75211,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6746 6.28216C11.3495 5.95638 10.9632 5.69801 10.538 5.52189C10.1128 5.34577 9.65693 5.25537 9.19667 5.25586C8.73642 5.25537 8.28059 5.34577 7.85536 5.52189C7.43013 5.69801 7.04387 5.95638 6.71875 6.28216",
    stroke: "black",
    strokeWidth: 1.75211,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5527 14.5527L18.2694 18.2694",
    stroke: "currentColor",
    strokeWidth: 1.75211,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.0253V21.0253H0V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.162ccf1a9608fa9f9cf2787d7e1f1430.svg";
export { ForwardRef as ReactComponent };